import React from "react";

import { BadgePropsColorOverrides, Tab, TabProps } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

import { IgBadge } from "./IgBadge";

interface IgTabProps extends TabProps {
  hasBadge?: boolean;
}

export const IgTab = (props: IgTabProps) => {
  const { label, hasBadge, sx, ...rest } = props;

  return (
    <Tab
      data-label={label}
      iconPosition={"end"}
      icon={
        hasBadge ? (
          <IgBadge
            variant={"dot"}
            // @ts-ignore
            color={"accent"}
            sx={{ pr: 1, mt: "-5px" }}
          />
        ) : undefined
      }
      label={label}
      {...rest}
    />
  );
};
